import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { SENSITIVE_STRING } from "@smithy/smithy-client";
import { InventoryConfigurationFilterSensitiveLog, ServerSideEncryptionConfigurationFilterSensitiveLog } from "./models_0";
import { S3ServiceException as __BaseException } from "./S3ServiceException";
export var MFADelete = {
  Disabled: "Disabled",
  Enabled: "Enabled"
};
export var EncryptionTypeMismatch = /*#__PURE__*/function (_BaseException) {
  _inherits(EncryptionTypeMismatch, _BaseException);
  var _super = _createSuper(EncryptionTypeMismatch);
  function EncryptionTypeMismatch(opts) {
    var _this;
    _classCallCheck(this, EncryptionTypeMismatch);
    _this = _super.call(this, _objectSpread({
      name: "EncryptionTypeMismatch",
      $fault: "client"
    }, opts));
    _this.name = "EncryptionTypeMismatch";
    _this.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this), EncryptionTypeMismatch.prototype);
    return _this;
  }
  return _createClass(EncryptionTypeMismatch);
}(__BaseException);
export var InvalidRequest = /*#__PURE__*/function (_BaseException2) {
  _inherits(InvalidRequest, _BaseException2);
  var _super2 = _createSuper(InvalidRequest);
  function InvalidRequest(opts) {
    var _this2;
    _classCallCheck(this, InvalidRequest);
    _this2 = _super2.call(this, _objectSpread({
      name: "InvalidRequest",
      $fault: "client"
    }, opts));
    _this2.name = "InvalidRequest";
    _this2.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this2), InvalidRequest.prototype);
    return _this2;
  }
  return _createClass(InvalidRequest);
}(__BaseException);
export var InvalidWriteOffset = /*#__PURE__*/function (_BaseException3) {
  _inherits(InvalidWriteOffset, _BaseException3);
  var _super3 = _createSuper(InvalidWriteOffset);
  function InvalidWriteOffset(opts) {
    var _this3;
    _classCallCheck(this, InvalidWriteOffset);
    _this3 = _super3.call(this, _objectSpread({
      name: "InvalidWriteOffset",
      $fault: "client"
    }, opts));
    _this3.name = "InvalidWriteOffset";
    _this3.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this3), InvalidWriteOffset.prototype);
    return _this3;
  }
  return _createClass(InvalidWriteOffset);
}(__BaseException);
export var TooManyParts = /*#__PURE__*/function (_BaseException4) {
  _inherits(TooManyParts, _BaseException4);
  var _super4 = _createSuper(TooManyParts);
  function TooManyParts(opts) {
    var _this4;
    _classCallCheck(this, TooManyParts);
    _this4 = _super4.call(this, _objectSpread({
      name: "TooManyParts",
      $fault: "client"
    }, opts));
    _this4.name = "TooManyParts";
    _this4.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this4), TooManyParts.prototype);
    return _this4;
  }
  return _createClass(TooManyParts);
}(__BaseException);
export var ObjectAlreadyInActiveTierError = /*#__PURE__*/function (_BaseException5) {
  _inherits(ObjectAlreadyInActiveTierError, _BaseException5);
  var _super5 = _createSuper(ObjectAlreadyInActiveTierError);
  function ObjectAlreadyInActiveTierError(opts) {
    var _this5;
    _classCallCheck(this, ObjectAlreadyInActiveTierError);
    _this5 = _super5.call(this, _objectSpread({
      name: "ObjectAlreadyInActiveTierError",
      $fault: "client"
    }, opts));
    _this5.name = "ObjectAlreadyInActiveTierError";
    _this5.$fault = "client";
    Object.setPrototypeOf(_assertThisInitialized(_this5), ObjectAlreadyInActiveTierError.prototype);
    return _this5;
  }
  return _createClass(ObjectAlreadyInActiveTierError);
}(__BaseException);
export var Tier = {
  Bulk: "Bulk",
  Expedited: "Expedited",
  Standard: "Standard"
};
export var ExpressionType = {
  SQL: "SQL"
};
export var CompressionType = {
  BZIP2: "BZIP2",
  GZIP: "GZIP",
  NONE: "NONE"
};
export var FileHeaderInfo = {
  IGNORE: "IGNORE",
  NONE: "NONE",
  USE: "USE"
};
export var JSONType = {
  DOCUMENT: "DOCUMENT",
  LINES: "LINES"
};
export var QuoteFields = {
  ALWAYS: "ALWAYS",
  ASNEEDED: "ASNEEDED"
};
export var RestoreRequestType = {
  SELECT: "SELECT"
};
export var SelectObjectContentEventStream;
(function (SelectObjectContentEventStream) {
  SelectObjectContentEventStream.visit = function (value, visitor) {
    if (value.Records !== undefined) return visitor.Records(value.Records);
    if (value.Stats !== undefined) return visitor.Stats(value.Stats);
    if (value.Progress !== undefined) return visitor.Progress(value.Progress);
    if (value.Cont !== undefined) return visitor.Cont(value.Cont);
    if (value.End !== undefined) return visitor.End(value.End);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
})(SelectObjectContentEventStream || (SelectObjectContentEventStream = {}));
export var PutBucketEncryptionRequestFilterSensitiveLog = function PutBucketEncryptionRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.ServerSideEncryptionConfiguration && {
    ServerSideEncryptionConfiguration: ServerSideEncryptionConfigurationFilterSensitiveLog(obj.ServerSideEncryptionConfiguration)
  });
};
export var PutBucketInventoryConfigurationRequestFilterSensitiveLog = function PutBucketInventoryConfigurationRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.InventoryConfiguration && {
    InventoryConfiguration: InventoryConfigurationFilterSensitiveLog(obj.InventoryConfiguration)
  });
};
export var PutObjectOutputFilterSensitiveLog = function PutObjectOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread(_objectSpread({}, obj), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  }), obj.SSEKMSEncryptionContext && {
    SSEKMSEncryptionContext: SENSITIVE_STRING
  });
};
export var PutObjectRequestFilterSensitiveLog = function PutObjectRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, obj), obj.SSECustomerKey && {
    SSECustomerKey: SENSITIVE_STRING
  }), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  }), obj.SSEKMSEncryptionContext && {
    SSEKMSEncryptionContext: SENSITIVE_STRING
  });
};
export var EncryptionFilterSensitiveLog = function EncryptionFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.KMSKeyId && {
    KMSKeyId: SENSITIVE_STRING
  });
};
export var S3LocationFilterSensitiveLog = function S3LocationFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.Encryption && {
    Encryption: EncryptionFilterSensitiveLog(obj.Encryption)
  });
};
export var OutputLocationFilterSensitiveLog = function OutputLocationFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.S3 && {
    S3: S3LocationFilterSensitiveLog(obj.S3)
  });
};
export var RestoreRequestFilterSensitiveLog = function RestoreRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.OutputLocation && {
    OutputLocation: OutputLocationFilterSensitiveLog(obj.OutputLocation)
  });
};
export var RestoreObjectRequestFilterSensitiveLog = function RestoreObjectRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.RestoreRequest && {
    RestoreRequest: RestoreRequestFilterSensitiveLog(obj.RestoreRequest)
  });
};
export var SelectObjectContentEventStreamFilterSensitiveLog = function SelectObjectContentEventStreamFilterSensitiveLog(obj) {
  if (obj.Records !== undefined) return {
    Records: obj.Records
  };
  if (obj.Stats !== undefined) return {
    Stats: obj.Stats
  };
  if (obj.Progress !== undefined) return {
    Progress: obj.Progress
  };
  if (obj.Cont !== undefined) return {
    Cont: obj.Cont
  };
  if (obj.End !== undefined) return {
    End: obj.End
  };
  if (obj.$unknown !== undefined) return _defineProperty({}, obj.$unknown[0], "UNKNOWN");
};
export var SelectObjectContentOutputFilterSensitiveLog = function SelectObjectContentOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.Payload && {
    Payload: "STREAMING_CONTENT"
  });
};
export var SelectObjectContentRequestFilterSensitiveLog = function SelectObjectContentRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSECustomerKey && {
    SSECustomerKey: SENSITIVE_STRING
  });
};
export var UploadPartOutputFilterSensitiveLog = function UploadPartOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  });
};
export var UploadPartRequestFilterSensitiveLog = function UploadPartRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSECustomerKey && {
    SSECustomerKey: SENSITIVE_STRING
  });
};
export var UploadPartCopyOutputFilterSensitiveLog = function UploadPartCopyOutputFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  });
};
export var UploadPartCopyRequestFilterSensitiveLog = function UploadPartCopyRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread(_objectSpread({}, obj), obj.SSECustomerKey && {
    SSECustomerKey: SENSITIVE_STRING
  }), obj.CopySourceSSECustomerKey && {
    CopySourceSSECustomerKey: SENSITIVE_STRING
  });
};
export var WriteGetObjectResponseRequestFilterSensitiveLog = function WriteGetObjectResponseRequestFilterSensitiveLog(obj) {
  return _objectSpread(_objectSpread({}, obj), obj.SSEKMSKeyId && {
    SSEKMSKeyId: SENSITIVE_STRING
  });
};